import {BLOCK_IS_ACTIVE} from "../actions/actionTypes";

export default function (state = [], action) {
    switch (action.type) {
        case BLOCK_IS_ACTIVE:
            // console.log("This is payload ", action.payload);
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/active_block.js